// Shared helpers over the access-model wire shapes (access.types.ts) that more
// than one feature needs — currently the users Access tab and the roles
// feature's catalog-role list, both of which have to single out migration
// bridge rows from otherwise-ordinary custom roles.

// Bridge role ids the legacy credential→role backfill (RoleMaterializationBackfill)
// wrote directly against real users; still genuine catalog rows/assignments
// today (custom: true), so they stay visible, but they are not a choice an
// admin should hand out or edit going forward — they exist for the migration
// and are torn down later.
export function isMigratedRoleId(roleId: string): boolean {
  return roleId.startsWith('role_') || roleId.startsWith('cred_')
}
